import React, { memo, useState } from "react";
import {
  Stack,
  ToggleButtonGroup,
  ToggleButton,
  FormGroup,
  FormControlLabel,
  Switch,
} from "investira.react.components";
import { INDICADORES } from "../../../../enums";
import { arrays } from "investira.sdk";
import SelectMenu from "./SelectMenu";

const Controls = memo((props) => {
  const { range = {}, ajustado = {}, type = {}, indicador = {} } = props;
  const [rangeSelected, setRangeSelected] = useState(range.selected);

  function handleSetRange(pType, pCount, pIndex) {
    range.setRange(pType, pCount, pIndex);
    setRangeSelected(pIndex);
  }

  function filterIndicadores(pIndicadores) {
    if (process.env.NODE_ENV === "development") {
      return Object.values(pIndicadores);
    }

    const indicadoresExcluidos = ["POUP", "IPCA", "IGPM"];
    return Object.values(pIndicadores).filter(
      (xIndicador) => !indicadoresExcluidos.includes(xIndicador.indicador_id)
    );
  }

  return (
    <Stack
      marginTop={{ xs: 2, md: 0 }}
      spacing={2}
      direction={{ xs: "column", md: "row" }}
      alignItems={{ md: "center" }}
      flexGrow={1}
      width={"100%"}
    >
      <Stack
        spacing={2}
        direction={"row"}
        flexGrow={1}
        justifyContent={{ xs: "space-between", md: "flex-end" }}
        alignItems={{ xs: "center" }}
      >
        {ajustado.onChange && (
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  defaultChecked
                  size="small"
                  onChange={(e) => ajustado.onChange(e.target.checked)}
                />
              }
              label="Ajustado"
              defaultChecked
              componentsProps={{ typography: { variant: "body2" } }}
            />
          </FormGroup>
        )}

        <Stack spacing={2} direction="row" sx={{ maxWidth: "200px" }}>
          {indicador.onChange && (
            <SelectMenu
              value={indicador.value}
              autoWidth={true}
              renderValue={(pValue) => {
                return pValue;
              }}
              options={filterIndicadores(INDICADORES).map(
                (xIndicador, xIndex) => {
                  return {
                    value: xIndicador.indicador_id,
                    label: `${xIndicador.indicador_id} - ${xIndicador.indicador}`,
                    index: xIndex,
                    disabled: false,
                  };
                }
              )}
              onChange={indicador.onChange}
            />
          )}

          {type.onChange && (
            <SelectMenu
              value={type.value}
              options={[
                { value: 0, label: "Cotação", disabled: false },
                { value: 1, label: "Volatilidade", disabled: true },
                { value: 2, label: "Drawdown", disabled: true },
                { value: 3, label: "Market Cap", disabled: true },
                { value: 4, label: "Valor Patrimonial", disabled: true },
              ]}
              onChange={type.onChange}
            />
          )}
        </Stack>
      </Stack>
      <Stack spacing={2} direction="row">
        <ToggleButtonGroup
          value={rangeSelected}
          size="small"
          color="primary"
          fullWidth
        >
          {range.buttons.map((xOption, xIndex) => {
            return (
              <ToggleButton
                key={xOption.text}
                onClick={() =>
                  handleSetRange(xOption.type, xOption.count, xIndex)
                }
                value={xIndex}
              >
                {xOption.text}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>
      </Stack>
    </Stack>
  );
});

export default Controls;
